/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Score_GoodInputs */

const en_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good effort`)
};

const de_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gute Leistung`)
};

const fr_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon effort`)
};

const es_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buen esfuerzo`)
};

const it_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buon lavoro`)
};

const nl_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goed gedaan`)
};

const pl_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobra robota`)
};

const fi_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyvä suoritus`)
};

const da_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godt arbejde`)
};

const sv_interview_practice_score_good = /** @type {(inputs: Interview_Practice_Score_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bra insats`)
};

/**
* | output |
* | --- |
* | "Good effort" |
*
* @param {Interview_Practice_Score_GoodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_score_good = /** @type {((inputs?: Interview_Practice_Score_GoodInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Score_GoodInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_score_good(inputs)
	if (locale === "fr") return fr_interview_practice_score_good(inputs)
	if (locale === "es") return es_interview_practice_score_good(inputs)
	if (locale === "it") return it_interview_practice_score_good(inputs)
	if (locale === "nl") return nl_interview_practice_score_good(inputs)
	if (locale === "pl") return pl_interview_practice_score_good(inputs)
	if (locale === "fi") return fi_interview_practice_score_good(inputs)
	if (locale === "da") return da_interview_practice_score_good(inputs)
	if (locale === "sv") return sv_interview_practice_score_good(inputs)
	return en_interview_practice_score_good(inputs)
});